module.exports = __webpack_public_path__ + "img/20210116_105718.7ae863a3.jpg";